import React, { FormEvent, useContext, useState } from 'react';
import { useAsyncFn } from 'react-use';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Alert, Button, Text, Notification, Input } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { useAccountContext } from 'contexts/account';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';
import { NOTIFICATION_DISPLAY_TIME } from 'domain/ux';
import { Page } from 'styles';
import { BackLink } from 'components/back-link';
import { UPDATE_ACCOUNT } from './account-nickname.api';

const getCopy = copyFor('settings.accountDetails.nickname');
const getServerError = copyFor('errors.server');
const { accountDetails } = routes();

export const AccountNickname = () => {
  const { selectedAccount } = useAccountContext();
  const history = useHistory();
  const { addNotification } = useContext(Notification.Context);

  const name = selectedAccount.name;
  const [nickname, setNickname] = useState(name || '');
  const [mutate] = useMutation(UPDATE_ACCOUNT);

  const [{ error: mutationError, loading: mutationLoading }, submit] =
    useAsyncFn(async () => {
      await mutate({
        variables: {
          id: selectedAccount.id,
          input: {
            name: nickname,
          },
        },
      });
      addNotification({
        displayTime: NOTIFICATION_DISPLAY_TIME,
        message: getCopy('toastNotification'),
        variant: 'success',
      });
    }, [mutate, selectedAccount, nickname, addNotification]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    await submit();
    history.push(accountDetails);
  };

  return (
    <>
      <BackLink to={accountDetails} />
      <Page maxWidth={MAX_SECONDARY_PAGE_WIDTH}>
        <Text textStyle="heading800" tag="h1" margin={{ bottom: '48px' }}>
          {getCopy('title')}
        </Text>
        <form onSubmit={handleSubmit}>
          <Input
            label={getCopy('label')}
            margin={{ bottom: '16px' }}
            name="nickname"
            onChange={setNickname}
            value={nickname}
          />
          {mutationError && (
            <Alert margin={{ top: '32px' }}>{getServerError('generic')}</Alert>
          )}
          <Button
            disabled={!nickname || nickname === name}
            fullWidth
            margin={{ top: '32px' }}
            loading={mutationLoading}
            type="submit"
          >
            {getCopy('button')}
          </Button>
        </form>
      </Page>
    </>
  );
};
